"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

function _default() {
  return {
    collapsed: false,
    links: [1, 2, 3, 4],
    linksById: {
      1: {
        id: 1,
        link: '#',
        title: 'FAQs',
        collapsed: false
      },
      2: {
        id: 2,
        link: '#',
        title: 'Contact',
        collapsed: true
      },
      3: {
        id: 3,
        link: '#',
        title: 'Track Order',
        collapsed: true
      },
      4: {
        id: 4,
        link: '#',
        title: 'Reviews',
        collapsed: true
      }
    },
    linkNextId: 5
  };
}